export default __webpack_public_path__ + "static/media/logo-ypf.5a4eea2c.svg";